import { render, staticRenderFns } from "./giftcards.vue?vue&type=template&id=17f0223d&lang=pug"
import script from "./giftcards.vue?vue&type=script&lang=js"
export * from "./giftcards.vue?vue&type=script&lang=js"
import style0 from "./giftcards.vue?vue&type=style&index=0&id=17f0223d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports